import { useEffect } from 'react';

export function WhatsAppWidget({ user }) {
  useEffect(() => {
    if (!user) return;

    const phone = '5521990257203';

    const message = `
Olá!
Vim da Central do Cliente e estou com dúvida. Pode me ajudar?
    `;

    const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

    // cria botão flutuante simples
    const button = document.createElement('a');
    button.href = url;
    button.target = '_blank';
    button.rel = 'noopener noreferrer';
    button.id = 'whatsapp-button';

    button.style.position = 'fixed';
    button.style.bottom = '20px';
    button.style.right = '20px';
    button.style.background = '#25D366';
    button.style.color = '#fff';
    button.style.padding = '12px 16px';
    button.style.borderRadius = '50px';
    button.style.fontWeight = 'bold';
    button.style.textDecoration = 'none';
    button.style.zIndex = '9999';

    button.innerText = 'Falar no WhatsApp';

    document.body.appendChild(button);

    return () => {
      const el = document.getElementById('whatsapp-button');
      if (el) el.remove();
    };
  }, [user]);

  return null;
}
